module.exports = __webpack_public_path__ + "img/admin-capture-formbuilder.48ea4c76.png";